import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    headers.set('client-version', `${process.env.REACT_APP_REDUX_V}`);
    return headers;
  },
});

const apiSlice = createApi({
  baseQuery,
  tagTypes: [],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({}),
});

export { apiSlice };
